import { useParams } from 'react-router-dom'

import { ResidentAppError } from '../../../common/error'

export const useCurrentContract = () => {
  const { contractId: currentContractId } = useParams()

  if (!currentContractId) {
    throw ResidentAppError.ClientError('NOT_FOUND', {
      message: 'No contractUuid found in params',
    })
  }

  return {
    currentContractId,
  }
}
